import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { UserService } from '../../shared/user.service';
import { HttpErrorResponse } from '@angular/common/http';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-user-detail',
  templateUrl: './user-detail.component.html',
  styleUrls: ['./user-detail.component.css']
})
export class UserDetailComponent implements OnInit {

  public userDetails: any;
  constructor(public route: ActivatedRoute, private router: Router, private userService: UserService) { }

  ngOnInit() {
    
    //let url = this.route.snapshot.url.join().split(',')
    let url = window.location.pathname;

    if (url.toLowerCase().startsWith('/message-view')) {
      this.userDetails = null;
      return;
    }

    this.userService.getUserClaims().subscribe((data: any) => {
      // alert("UserDetailComponent init");
      // alert(data);
      this.userDetails = data;

    },
    (err : HttpErrorResponse)=>{
      this.userDetails = null;
    });
  }


  Logout() {
    localStorage.removeItem('userToken');
    //this.router.navigate(['/login']);
    window.location.href = "/login";
    
  }

}



// WEBPACK FOOTER //
// C:/ProjectsOnGit/Pensioner/PensionerPnoCharger/PnoCharger/Client/src/app/user/user-detail/user-detail.component.ts